export default "__VITE_ASSET__CrmWuRAS__"